/* A Leading Role - birthday points on the Front Row panel.
 *
 * 1,000 points arrive three days before a member's birthday and are gone three
 * days after it. This is where they tell us the date, and where they are told
 * the points have landed and when they go.
 *
 * Month and day only. A birth year is a piece of identity a costume shop has
 * no business holding, so the form does not offer one.
 *
 * Additive: a separate asset that waits for alr-frontrow-points.js to build
 * .frp-card, then appends to it. That file is already long and is the thing
 * most likely to be edited next; keeping this apart means neither has to be
 * rewritten to change the other.
 */
(function () {
  var STATUS = '/apps/concierge/membership/status';
  var SAVE = '/apps/concierge/membership/birthday';

  var CREAM = '#FBF7F0';
  var GOLD = '#E3BE45';
  var SOFT = '#D9C6C9';

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  var MAX_DAY = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function num(n) {
    return String(Number(n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function dayMonth(iso) {
    try {
      return new Date(iso).toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
    } catch (err) {
      return '';
    }
  }

  function styles() {
    if (document.getElementById('fr-bday-style')) return;
    var s = document.createElement('style');
    s.id = 'fr-bday-style';
    s.textContent = [
      '.frb{margin-top:22px;padding-top:20px;border-top:1px solid rgba(227,190,69,.24);text-align:center}',
      '.frb-k{font-size:9.5px;letter-spacing:.2em;text-transform:uppercase;color:' + GOLD + ';margin-bottom:9px}',
      '.frb-t{margin:0;font-size:12.5px;line-height:1.6;color:' + SOFT + '}',
      '.frb-t i{font-style:normal;color:' + CREAM + '}',
      '.frb-live{margin:0;font-size:14px;line-height:1.6;color:' + CREAM + '}',
      '.frb-live b{color:' + GOLD + ';font-weight:400}',
      '.frb-form{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-top:12px}',
      '.frb-form select{font:inherit;font-size:13px;padding:8px 10px;border-radius:3px;',
      'border:1px solid rgba(227,190,69,.5);background:#FBF7F0;color:#2A1A1C}',
      '.frb-form button{font:inherit;font-size:11px;letter-spacing:.13em;text-transform:uppercase;',
      'padding:9px 18px;border-radius:3px;cursor:pointer;border:1px solid ' + GOLD + ';',
      'background:transparent;color:' + GOLD + ';transition:.16s}',
      '.frb-form button:hover:not(:disabled){background:' + GOLD + ';color:#3E0C16}',
      '.frb-form button:disabled{opacity:.55;cursor:default}',
      '.frb-edit{margin-top:9px;font-size:11px;letter-spacing:.1em;text-transform:uppercase;',
      'color:' + SOFT + ';background:none;border:0;cursor:pointer;text-decoration:underline;font-family:inherit}',
      '.frb-err{margin-top:10px;font-size:12px;color:#F3B0B0}'
    ].join('');
    document.head.appendChild(s);
  }

  function selects(current) {
    var form = el('div', 'frb-form');

    var month = document.createElement('select');
    month.setAttribute('aria-label', 'Birth month');
    for (var i = 0; i < 12; i++) {
      var o = document.createElement('option');
      o.value = String(i + 1);
      o.textContent = MONTHS[i];
      month.appendChild(o);
    }

    var day = document.createElement('select');
    day.setAttribute('aria-label', 'Birth day');

    function fillDays() {
      var max = MAX_DAY[Number(month.value) - 1];
      var keep = Number(day.value) || 1;
      day.innerHTML = '';
      for (var d = 1; d <= max; d++) {
        var o = document.createElement('option');
        o.value = String(d);
        o.textContent = String(d);
        day.appendChild(o);
      }
      day.value = String(Math.min(keep, max));
    }

    if (current) {
      month.value = String(current.month);
      fillDays();
      day.value = String(current.day);
    } else {
      fillDays();
    }
    month.addEventListener('change', fillDays);

    var save = el('button', null, 'Save');
    save.setAttribute('type', 'button');

    form.appendChild(month);
    form.appendChild(day);
    form.appendChild(save);
    return { form: form, month: month, day: day, save: save };
  }

  function render(box, d) {
    box.innerHTML = '';
    styles();

    // The window is open: this is the only thing worth saying.
    if (d.birthdayActive && d.birthdayRemaining > 0) {
      box.appendChild(el('div', 'frb-k', 'Happy birthday'));
      var live = el('p', 'frb-live');
      live.appendChild(document.createTextNode('Your '));
      var b = el('b', null, num(d.birthdayRemaining) + ' birthday points');
      live.appendChild(b);
      live.appendChild(document.createTextNode(
        ' are in your balance. They go after ' + dayMonth(d.birthdayExpiresAt) + '.'
      ));
      box.appendChild(live);
      return;
    }

    box.appendChild(el('div', 'frb-k', 'Birthday points'));

    var parts = d.birthday ? d.birthday.split('-') : null;
    var current = parts ? { month: Number(parts[0]), day: Number(parts[1]) } : null;

    if (current) {
      var t = el('p', 'frb-t');
      t.appendChild(document.createTextNode(num(d.birthdayPoints) + ' points arrive '));
      t.appendChild(el('i', null, d.birthdayOpensAt ? dayMonth(d.birthdayOpensAt) : 'before your birthday'));
      t.appendChild(document.createTextNode(
        ' and are yours for ' + ((d.birthdayWindowDays * 2) + 1) + ' days — three before, ' +
        'the day itself, and three after.'
      ));
      box.appendChild(t);

      var edit = el('button', 'frb-edit', 'Change my birthday');
      edit.setAttribute('type', 'button');
      box.appendChild(edit);
      edit.addEventListener('click', function () {
        box.removeChild(edit);
        attach(box, d, current);
      });
      return;
    }

    box.appendChild(el(
      'p',
      'frb-t',
      'Tell us the day and we will put ' + num(d.birthdayPoints) + ' points in your balance for ' +
      'the week around it — three days before, the day itself, and three after. ' +
      'No year, just the date.'
    ));
    attach(box, d, null);
  }

  function attach(box, d, current) {
    var ui = selects(current);
    box.appendChild(ui.form);

    ui.save.addEventListener('click', function () {
      if (ui.save.disabled) return;
      ui.save.disabled = true;
      ui.save.textContent = 'Saving…';

      var old = box.querySelector('.frb-err');
      if (old) old.parentNode.removeChild(old);

      fetch(SAVE, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ month: Number(ui.month.value), day: Number(ui.day.value) })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok || !res.j || !res.j.signedIn) {
            ui.save.disabled = false;
            ui.save.textContent = 'Save';
            box.appendChild(el('p', 'frb-err', (res.j && res.j.error) || 'That did not save. Please try again.'));
            return;
          }
          render(box, res.j);
          // Landing inside the window means points just moved; the figures
          // above this block are now stale, so show them the fresh ones.
          if (res.j.birthdayActive) setTimeout(function () { window.location.reload(); }, 1400);
        })
        .catch(function () {
          ui.save.disabled = false;
          ui.save.textContent = 'Save';
          box.appendChild(el('p', 'frb-err', 'That did not save. Please try again.'));
        });
    });
  }

  function mount(card, d) {
    if (card.querySelector('.frb')) return;
    var box = el('div', 'frb');
    card.appendChild(box);
    render(box, d);
  }

  function start() {
    // Only where the panel lives, and only once it has been built.
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var card = document.querySelector('.frp-card');
      if (card) {
        clearInterval(timer);
        fetch(STATUS, { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d || !d.signedIn || !d.member) return;
            mount(card, d);
          })
          .catch(function () {});
      } else if (tries > 40) {
        clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
